import { z } from "zod";

import {
  insertLocationsTypeSchema,
  publicLocationStatusEnumSchema,
  publicLocationTypeEnumSchema,
  publicProvinceEnumSchema,
  rowLocationsTypeSchema,
  updateLocationsTypeSchema,
} from "@libs/schemas";
import { formatLocationStatus, formatLocationType } from "@/utils/location";

import { campusesIdsSchema, campusesRelationSchema } from "./campus";

export type ProvinceType = z.infer<typeof publicProvinceEnumSchema>;

export const locationSchema = rowLocationsTypeSchema.merge(
  campusesRelationSchema,
);
export type LocationType = z.infer<typeof locationSchema>;

export type LocationTypesType = z.infer<typeof publicLocationTypeEnumSchema>;
export type LocationStatusType = z.infer<typeof publicLocationStatusEnumSchema>;

export type LocationInsertType = z.infer<typeof insertLocationsTypeSchema>;
export type LocationUpdateFormType = z.infer<typeof updateLocationsTypeSchema>;

export const locationFormSchema = insertLocationsTypeSchema
  .merge(campusesIdsSchema)
  .omit({
    id: true,
    created_at: true,
    updated_at: true,
    geo_point: true,
    full_text_search: true,
  });
export type LocationFormType = z.infer<typeof locationFormSchema>;

export const locationFilterSchema = z.object({
  search: z.string().optional().catch(""),
  provinces: z.array(publicProvinceEnumSchema).optional().catch([]),
  statuses: z.array(publicLocationStatusEnumSchema).optional().catch([]),
  campusesIds: z.array(z.string()).optional().catch([]),
  locationTypes: z.array(publicLocationTypeEnumSchema).optional(),
});
export type LocationFilterType = z.infer<typeof locationFilterSchema>;

export const locationSearchParamsSchema = locationFilterSchema.extend({
  id: z.string().uuid().optional().catch(""),
});

export const locationsProvincesOptions = publicProvinceEnumSchema.options.map(
  province => ({
    label: province,
    value: province,
  }),
);

export const locationTypesOptions = publicLocationTypeEnumSchema.options.map(
  type => ({
    label: formatLocationType(type),
    value: type,
  }),
);

export const locationStatusOptions = publicLocationStatusEnumSchema.options.map(
  status => ({
    label: formatLocationStatus(status),
    value: status,
  }),
);
